import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import BasePageUAM from '../BasePageUAM/BasePageUAM';
import Step2RegistrationPanel from './Panels/Step2RegistrationPanel/Step2RegistrationPanel';
import RegistrationCompletePanel from '../../shared-panels/uam/RegistrationCompletePanel/RegistrationCompletePanel';
import BusyOverlay from '../../shared-panels/uam/BusyOverlay/BusyOverlay';

const RegistrationStep2Page = ({ brand, destPath }) => {
  const [isBusy, setIsBusy] = useState(false);
  const [isRegistrationComplete, setIsRegistrationComplete] = useState(false);
  const isNewRegistration = useRef(localStorage.getItem('is_new_registration') === 'true');

  if (isNewRegistration.current) {
    localStorage.removeItem('is_new_registration');
  }

  return (
    <BasePageUAM activeTab={2} brand={brand} destPath={destPath} needsDestPath showTabs={!isRegistrationComplete}>
      { isBusy && <BusyOverlay /> }
      {
        isRegistrationComplete
          ? <RegistrationCompletePanel isPriorRegistration={false} />
          : <Step2RegistrationPanel
            brand={brand}
            destPath={destPath}
            setIsRegistrationComplete={setIsRegistrationComplete}
            isNewRegistration={isNewRegistration.current}
            setIsBusy={setIsBusy}
          />
      }
    </BasePageUAM>
  );
};

RegistrationStep2Page.propTypes = {
  brand: PropTypes.object.isRequired,
  destPath: PropTypes.object.isRequired,
};

export default RegistrationStep2Page;
